import React from "react";
import { FieldValues, FormState } from "react-hook-form";

import { FormDebug } from "./FormDebug";

interface HookFormDebugProps {
  watch: () => FieldValues;
  formState: FormState<FieldValues>;
  isSubmitting: boolean;
  isSubmittable: boolean;
}

export const HookFormDebug: React.FC<HookFormDebugProps> = ({ watch, formState, isSubmittable, isSubmitting }) => {
  const { errors } = formState;

  return (
    <FormDebug
      errors={errors}
      values={watch()}
      isDirty={formState.isDirty}
      isValid={formState.isValid}
      isSubmittable={isSubmittable}
      isSubmitting={isSubmitting}
    />
  );
};
